<template>
    <div class="py-4 container-fluid">      
        <div class="card-body">
            <div class="row">
                <div class="col-lg-12">
                    <div class="row mb-5">
                        <div class="col-lg-3">
                            <edit-missing-side-nav />
                        </div>
                        <div class="col-lg-9 mt-lg-0 mt-4">
                            <missing-detail />
                        </div>
                    </div>
                </div>
            </div>
            <div class="row"></div>
        </div>
    </div>        
</template>
<script>
import EditMissingSideNav from "./components/EditMissingSideNav.vue"
import MissingDetail from "./components/MissingDetail.vue"

export default {
    name: 'AnimalMissing_edit_page',
    components: {
        EditMissingSideNav,
        MissingDetail
    },
    data() {
        return {
            Id: '',
            animal: [],
            gets: []
        }
    },
    async mounted() {        
    },
}
</script>